export default "__VITE_ASSET__$xGGvmIK__"